












































































import { Component, Vue } from "vue-property-decorator";
import setUpDialog from "./setUpDialog.vue";
import {
  switchDetailApi,
  switchModifyApi,
  courseExceedTotalApi,
} from "@/api/storeManagement";
// import setUpDrawer from "./setUpDrawer.vue";
import setRenewDrawer from "./setRenewDrawer.vue";
@Component({
  name: "storeConfigure",
  components: {
    setUpDialog,
    // setUpDrawer,
    setRenewDrawer,
  },
})
export default class extends Vue {
  form: any = {
    student_superupper: true,
    automatic_make_up: true,
    free_courses: true,
  };
  total: string = "";
  created() {
    const switchDetail: any = localStorage.getItem("switch_type");
    if (switchDetail !== null) {
      this.form.free_courses = JSON.parse(switchDetail).free_courses;
      this.form.student_superupper =
        JSON.parse(switchDetail).student_superupper;
      this.form.automatic_make_up = JSON.parse(switchDetail).automatic_make_up;
    }
    courseExceedTotalApi().then((res: any) => {
      if (res.error_code === 0) {
        this.total = res.data.total;
      }
    });
  }
  handleChangeSwitch() {
    if (this.form.student_superupper === false) {
      if (this.total !== "") {
        this.$confirm(
          `关闭超上后，点名时无法超过学员剩余课时数，且关闭后已超上的课次记录正常显示。`,
          `学员超上 - 共有 ${this.total} 个超上课时`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            type: "warning",
          }
        )
          .then(() => {
            this.changeSwitch("student_exceed", 2);
            this.form.student_superupper = false;
          })
          .catch(() => {
            this.form.student_superupper = true;
          });
      } else {
        this.changeSwitch("student_exceed", 2);
      }
    } else {
      this.changeSwitch("student_exceed", 1);
      this.form.student_superupper = true;
    }
    localStorage.setItem("switch_type", JSON.stringify(this.form));
  }
  handleChangeMakeUp() {
    if (this.form.automatic_make_up) {
      this.changeSwitch("student_exceed_automatic_sub", 1);
    } else {
      this.changeSwitch("student_exceed_automatic_sub", 2);
    }
    localStorage.setItem("switch_type", JSON.stringify(this.form));
  }
  handleChangeFreeCourses() {
    if (this.form.free_courses) {
      this.changeSwitch("free_arrange_lesson", 1);
    } else {
      this.changeSwitch("free_arrange_lesson", 2);
    }
    localStorage.setItem("switch_type", JSON.stringify(this.form));
  }
  changeSwitch(key: string, val: number) {
    switchModifyApi({
      key: key,
      status: val,
    })
      .then((res: any) => {
        if (res.error_code === 0) {
          this.$message({
            type: "success",
            message: val === 1 ? "已开启" : "已关闭",
          });
        }
      })
      .catch(() => {
        if (key === "student_exceed") {
          this.form.student_superupper = !this.form.student_superupper;
        }
        if (key === "student_exceed_automatic_sub") {
          this.form.automatic_make_up = !this.form.automatic_make_up;
        }
        if (key === "free_arrange_lesson") {
          this.form.free_courses = !this.form.free_courses;
        }
        localStorage.setItem("switch_type", JSON.stringify(this.form));
      });
  }
  beforeDestroy() {
    // 获取门店配置开关详情存储到localStorage
    switchDetailApi().then((res: any) => {
      if (res.error_code === 0) {
        const switchDetail: any = {
          free_courses: false,
          student_superupper: false,
          automatic_make_up: false,
          renew_auto_switch: false,
          renew_lesson_count: 5,
          renew_push_time: "09:00",
          new_buy_renew_time: 30,
        };
        switchDetail.free_courses = res.data.free_arrange_lesson === 1;
        switchDetail.student_superupper = res.data.student_exceed === 1;
        switchDetail.automatic_make_up =
          res.data.student_exceed_automatic_sub === 1;
        switchDetail.renew_auto_switch = res.data.renew_auto_switch === 1;
        switchDetail.renew_lesson_count = res.data.renew_lesson_count;
        switchDetail.renew_push_time = res.data.renew_push_time;
        switchDetail.new_buy_renew_time = res.data.new_buy_renew_time;
        localStorage.setItem("switch_type", JSON.stringify(switchDetail));
      }
    });
  }
}
